import React, { forwardRef, useImperativeHandle, useState } from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "common/const/colors";
import { textStylePlaceholder } from "..";

export const ToastProvider = forwardRef(({ children }, ref) => {
  const [toasts, setToasts] = useState([]);

  const addToast = (message, duration = 3000) => {
    const id = Date.now();
    setToasts([{ id, message, duration }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  };

  useImperativeHandle(ref, () => ({ addToast }));

  return (
    <>
      {children}
      <ToastContainer>
        {toasts.map((toast) => (
          <Toast key={toast.id} $duration={toast.duration}>
            {toast.message}
          </Toast>
        ))}
      </ToastContainer>
    </>
  );
});

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
`;

const ToastContainer = styled.div`
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  pointer-events: none;
`;

const Toast = styled.div`
  ${textStylePlaceholder}
  padding: 1rem 1.5rem;
  background: ${colors.DarkNavy};
  color: ${colors.White};
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px ${colors.withOpacity(colors.Black, 0.1)};
  animation: ${fadeInOut} ${({ $duration }) => $duration}ms ease forwards;
  white-space: nowrap;
`;
